module.exports = __webpack_public_path__ + "static/zui16_img/product06-img1.48f14c56.png";